import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton, useTheme } from '@mui/material';
import { Facebook as FacebookIcon, Twitter as TwitterIcon, Instagram as InstagramIcon, LinkedIn as LinkedInIcon } from '@mui/icons-material';
import { tokens } from "../../theme";

const Footer = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: colors.CatoAccent[500],
        color: colors.softWhiteAccent[500], // Aplica el color deseado a todo el texto
        py: 3,
        borderTop: `1px solid ${theme.palette.divider}`,
        position: 'relative',
        bottom: 0,
        width: '100%',
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-evenly">
          {/** Sección de Acerca de Nosotros */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom>
              Acerca de nosotros
            </Typography>
            <Typography variant="body2">
            Somos una universidad católica, que garantiza la presencia del catolicismo en la educación superior de Honduras y nuestra formación integral es en función de las distintas dimensiones del ser humano; lo moral, lo espiritual, lo científico, lo técnico y lo religioso.
            </Typography>
          </Grid>
          {/** Sección de Contacto */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom>
              Contáctanos
            </Typography>
            <Typography variant="body2">Tegucigalpa, Honduras</Typography>
            <Typography variant="body2">Email: admisiones@unicah.edu</Typography>
            
          </Grid>
          {/** Sección de Enlaces Rápidos */}
         
          {/** Sección de Redes Sociales */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom>
              Síguenos
            </Typography>
            <Box>
              {[
                { label: 'Sitio Web', icon: <TwitterIcon />, url: 'https://x.com/UNICAH_HN' },
                { label: 'Facebook', icon: <FacebookIcon />, url: 'https://www.facebook.com/UNICAHSCJ' },                
                { label: 'Instagram', icon: <InstagramIcon />, url: 'https://www.instagram.com/unicahscj/' },
                { label: 'LinkedIn', icon: <LinkedInIcon />, url: 'https://hn.linkedin.com/school/universidad-cat%C3%B3lica-de-honduras-%27nuestra-se%C3%B1ora-reina-de-la-paz%27/' },
              ].map(({ label, icon, url }) => (
                <IconButton key={label} aria-label={label} color="inherit" href={url}>
                  {icon}
                </IconButton>
              ))}
            </Box>
          </Grid>
        </Grid>
        <Box mt={5}>
          <Typography variant="body2" align="center">           
            <Link color="inherit" href="https://www.unicah.edu/">
              UNICAH
            </Link>{' '}           
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
